import React from 'react';
import { TextFields, Image, VideoLibrary, Description } from '@mui/icons-material';

/**
 * Get icon component based on WhatsApp template type
 * @param {string} type - The template type (text, image, video, document)
 * @param {object} iconProps - Additional props for the icon (optional)
 */
export const getWhatsAppTemplateTypeIcon = (type, iconProps = {}) => {
  const defaultProps = { fontSize: "small", sx: { mr: 1 }, ...iconProps };
  switch (type?.toLowerCase()) {
    case "text":
      return <TextFields {...defaultProps} />;
    case "image":
      return <Image {...defaultProps} />;
    case "video":
      return <VideoLibrary {...defaultProps} />;
    case "document":
      return <Description {...defaultProps} />;
    default:
      return <TextFields {...defaultProps} />;
  }
};
